import router from "@/router";
import { useAuth } from "./useAuth";
import useAuthUser from "./useAuthUser";

const useHasPermissionUser = () => {
  const { hasPermissionUser, abilities, user } = useAuth();

  const redirectTo404 = (permission: string, entityType: string) => {
    if (!hasPermissionUser(permission, entityType)) {
      return router.push({
        path: "/error/not-found",
      });
    }
  };

  const isUserInternalWithPermission = (
    permission: string,
    entityType: string,
  ) => {
    return hasPermissionUser(permission, entityType) && user.value?.internal;
  };

  return {
    hasPermissionUser,
    redirectTo404,
    abilities,
    isUserInternalWithPermission,
  };
};

export default useHasPermissionUser;
